import { render, staticRenderFns } from "./accept-task-dialog.vue?vue&type=template&id=792ae58a&"
import script from "./accept-task-dialog.vue?vue&type=script&lang=js&"
export * from "./accept-task-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports